import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  id: {
    fontSize: 12,
  },
  duplicateWarning: {
    paddingTop: 16,
  },
  duplicateLine: {
    backgroundColor: '#fff4e5',
  },
}));

export default useStyles;
